import PropTypes from 'prop-types';

import {THEMES} from '@asdf-constants';

export const Props = {
  /**
   * Rank of the heading
   */
  rank: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7]),
  /**
   * Theme of the heading
   */
  theme: PropTypes.oneOf(Object.values(THEMES)),
  /**
   * Variant of the heading
   */
  variant: PropTypes.oneOf(['default', 'uppercase']),
  /**
   * HTML tag or ReactNode
   */
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  /**
   * For CSS customization
   */
  className: PropTypes.string,
};
